import { SIGNING_STATUSES, SIGNING_TYPES } from "../constants";

export const SIGNING_STATUSES_TITLES = {
  [SIGNING_TYPES.SIGN]: {
    [SIGNING_STATUSES.CHECKING_SIGNING_POSSIBILITY]: "Почти готово",
    [SIGNING_STATUSES.READY_TO_BE_SIGNED]: "Готово к подписанию",
    [SIGNING_STATUSES.IS_SIGNING]: "Идёт подписание",
    [SIGNING_STATUSES.SIGNING_STOPPED]: "Подписание остановлено",
    [SIGNING_STATUSES.SIGNING_COMPLETED]: "Документы подписаны",
    [SIGNING_STATUSES.ERROR]: "Произошла ошибка!",
  },
  [SIGNING_TYPES.VISE]: {
    [SIGNING_STATUSES.CHECKING_SIGNING_POSSIBILITY]: "Почти готово",
    [SIGNING_STATUSES.READY_TO_BE_SIGNED]: "Готово к визированию",
    [SIGNING_STATUSES.IS_SIGNING]: "Идёт визирование",
    [SIGNING_STATUSES.SIGNING_STOPPED]: "Визирование остановлено",
    [SIGNING_STATUSES.SIGNING_COMPLETED]: "Документы завизированы",
    [SIGNING_STATUSES.ERROR]: "Произошла ошибка!",
  },
};

export const SIGNING_STATUSES_ANNOTATIONS = {
  [SIGNING_TYPES.SIGN]: {
    [SIGNING_STATUSES.CHECKING_SIGNING_POSSIBILITY]: "Проверяем статусы",
    [SIGNING_STATUSES.SIGNING_STOPPED]:
      "Проверьте доступность закрытого ключа и сертификата",
    [SIGNING_STATUSES.ERROR]: "Не удалось подписать документы",
    [SIGNING_STATUSES.SIGNING_COMPLETED]:
      "Вы подписали документы\u000A с помощью электронной подписи",
    DOCUMENT_ERROR: "Невозможно подписать документ",
  },
  [SIGNING_TYPES.VISE]: {
    [SIGNING_STATUSES.CHECKING_SIGNING_POSSIBILITY]: "Проверяем статусы",
    [SIGNING_STATUSES.SIGNING_STOPPED]:
      "Проверьте доступность закрытого ключа и сертификата",
    [SIGNING_STATUSES.ERROR]: "Не удалось завизировать документы",
    [SIGNING_STATUSES.SIGNING_COMPLETED]:
      "Вы завизировали документы\u000A с помощью электронной подписи",
    DOCUMENT_ERROR: "Невозможно завизировать документ",
  },
};

export const SIGNING_DOCUMENTS_ANNOTATION_PLACEHOLDERS = {
  RUB_DOCUMENTS_TOTAL_VALUE: "%RUB_DOCUMENTS_TOTAL_VALUE%",
  VALID_RUB_DOCUMENTS_TOTAL_COUNT: "%VALID_RUB_DOCUMENTS_TOTAL_COUNT%",
  DOCUMENTS_TOTAL_COUNT: "%DOCUMENTS_TOTAL_COUNT%",
};

export const SIGNING_DOCUMENTS_ANNOTATION_DICTIONARY = {
  FIRST_WORD: "Всего",
  RUB_DOCS_SUM_TEXT: ",\u000A  на  сумму  %RUB_DOCUMENTS_TOTAL_VALUE%₽",
  RUB_DOCS_TEXT: ", из них %VALID_RUB_DOCUMENTS_TOTAL_COUNT%",
  DOCUMENTS_TOTAL: " из %DOCUMENTS_TOTAL_COUNT%",
};

export const SIGNING_STATUSES_SUBANNOTATIONS = {
  [SIGNING_TYPES.SIGN]: {
    [SIGNING_STATUSES.IS_SIGNING]: "Не закрывайте окно, пока всё не подпишется",
  },
  [SIGNING_TYPES.VISE]: {
    [SIGNING_STATUSES.IS_SIGNING]:
      "Не закрывайте окно, пока визирование не будет завершено",
  },
};

export const SIGNING_STATUSES_WIDGET_COLORS = {
  [SIGNING_STATUSES.CHECKING_SIGNING_POSSIBILITY]: "grey",
  [SIGNING_STATUSES.READY_TO_BE_SIGNED]: "grey",
  [SIGNING_STATUSES.IS_SIGNING]: "blue",
  [SIGNING_STATUSES.SIGNING_STOPPED]: "orange",
  [SIGNING_STATUSES.ERROR]: "orange",
  [SIGNING_STATUSES.SIGNING_COMPLETED]: "green",
};

export const SIGNING_WIDGET_BUTTON_TITLES = {
  [SIGNING_TYPES.SIGN]: {
    SIGN_ALL: "Подписать всё",
    STOP: "Прервать операцию",
    RETURN: "Вернуться в историю",
    SIGNING_STOPPED: "Продолжить подписание",
  },
  [SIGNING_TYPES.VISE]: {
    SIGN_ALL: "Завизировать всё",
    STOP: "Прервать операцию",
    RETURN: "Вернуться в историю",
    SIGNING_STOPPED: "Продолжить визирование",
  },
};
